import { Link } from 'react-router-dom'
import { useEffect, useMemo } from 'react'

import { WidthWrap } from '../scene/WidthWrap'
import { useAuth, useCurrentWorkspace, useUserProfile } from '../../store/hooks'

export const WorkspaceNotFound = ({
  workspaceId,
}: {
  workspaceId?: string
}) => {
  const { hasFetchedWorkspaces } = useCurrentWorkspace()
  const { userId } = useAuth()
  const { profile } = useUserProfile()

  const isMissingPersonalWorkspace = useMemo(() => {
    return hasFetchedWorkspaces && workspaceId === userId
  }, [workspaceId, userId, hasFetchedWorkspaces])

  useEffect(() => {
    if (isMissingPersonalWorkspace && userId) {
      console.error('Missing personal workspace')
    }
  }, [isMissingPersonalWorkspace, profile, userId])

  return (
    <WidthWrap>
      <div className="flex flex-col items-center justify-center h-screen space-y-4">
        <h1 className="text-2xl font-bold">Workspace not found</h1>
        <p className="text-lg">
          The workspace you are looking for does not exist.
        </p>
        <Link to="/" className="text-blue-500">
          Go back to the home page
        </Link>
      </div>
    </WidthWrap>
  )
}
